document.addEventListener('DOMContentLoaded',()=>{
    const accordion_headers = document.querySelectorAll('.accordion-header');
    // console.log(accordion_headers)

    accordion_headers.forEach((accordion_header) => {
        const accordion_body = accordion_header.querySelector('.accordion-body')
        const arrow = accordion_header.querySelector('.down-arrow')
        console.log(accordion_body)
        accordion_header.addEventListener('click', () => {
            accordion_body.classList.toggle('active');
            accordion_header.classList.toggle('active')
            arrow.classList.toggle("active")
        })
        
    });
})